import RecorteGasto from "../icons/RecorteGasto";

export default function DividirGastos() {
  return (
    <section className="dividirGastos">
      <div className="wrapper">
        <div className="texto">
          <h1>PODÉS DIVIDIR ESTE GASTO CON TUS CONTACTOS</h1>
          <p>Dividir gasto</p>
        </div>
        <RecorteGasto />
      </div>
    </section>
  );
}
